import { NgModule } from "@angular/core";
import { provideEffects } from "@ngrx/effects";
import { provideState, StoreModule } from "@ngrx/store";
import * as fromInventory from "./inventory.reducer";
import { InventoryEffects } from "./inventory.effects";
@NgModule({
    providers: [
        provideEffects(InventoryEffects),
        provideState(fromInventory.INVENTORY_FEATURE_KEY, fromInventory.inventoryReducer, {
            metaReducers: [fromInventory.inventoryHydrationMetaReducer],
        }),
    ],
})
export class InventoryStoreModule {}
